export var ScheduledTransferFrequencyUnit;

(function (ScheduledTransferFrequencyUnit) {
  ScheduledTransferFrequencyUnit["Day"] = "Day";
  ScheduledTransferFrequencyUnit["Week"] = "Week";
  ScheduledTransferFrequencyUnit["Month"] = "Month";
})(ScheduledTransferFrequencyUnit || (ScheduledTransferFrequencyUnit = {}));

export var ScheduledTransferDirection;

(function (ScheduledTransferDirection) {
  ScheduledTransferDirection["Incoming"] = "Incoming";
  ScheduledTransferDirection["Outgoing"] = "Outgoing";
})(ScheduledTransferDirection || (ScheduledTransferDirection = {}));

export var ScheduledTransferMechanism;

(function (ScheduledTransferMechanism) {
  ScheduledTransferMechanism["Ach"] = "Ach";
  ScheduledTransferMechanism["Wire"] = "Wire";
  ScheduledTransferMechanism["Check"] = "Check";
})(ScheduledTransferMechanism || (ScheduledTransferMechanism = {}));

export var ScheduledTransferState;

(function (ScheduledTransferState) {
  ScheduledTransferState["Active"] = "Active";
  ScheduledTransferState["Cancelled"] = "Cancelled";
  ScheduledTransferState["Completed"] = "Completed";
  ScheduledTransferState["Failed"] = "Failed";
})(ScheduledTransferState || (ScheduledTransferState = {}));

export var ScheduledTransferDeliveryMethod;

(function (ScheduledTransferDeliveryMethod) {
  ScheduledTransferDeliveryMethod["Standard"] = "Standard";
  ScheduledTransferDeliveryMethod["Express"] = "Express";
})(ScheduledTransferDeliveryMethod || (ScheduledTransferDeliveryMethod = {}));